import React, { useEffect } from 'react';

import { useEvent } from '../../utils/analytics/useEvent';
import { usePageLoadEvent } from '../../utils/analytics/usePageLoadEvent';
import { TWO_FACTOR_ENROLLMENT_PROMPTED_KEY } from '../../utils/constants';

import { SignUpFormContextProvider } from './SignUpFormContext';
import { SignUpForm } from './form';

export function SignUp() {
  usePageLoadEvent('sign up', 'home');
  const trackEvent = useEvent();

  // Reset the flag so that a second user signing up in the same browser tab is still prompted for MFA enrollment
  useEffect(() => {
    sessionStorage.removeItem(TWO_FACTOR_ENROLLMENT_PROMPTED_KEY);
  }, []);

  useEffect(() => {
    trackEvent('identity – mlife registration - start', 'start mlife registration process', 'mliferegstart');
  }, [trackEvent]);

  return (
    <SignUpFormContextProvider>
      <SignUpForm />
    </SignUpFormContextProvider>
  );
}

SignUp.displayName = 'SignUp';
